var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.export_id)?_c('b-tabs',[_c('b-tab',{attrs:{"title":"Imports","active":""}},[_c('ResultImportServerTable',{attrs:{"export_id":_vm.export_id}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }